import { Amplify } from 'aws-amplify';

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
      userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID || '',
      identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID || '',
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: 'code' as const,
      userAttributes: {
        email: {
          required: true,
        },
        name: {
          required: true,
        },
      },
      allowGuestAccess: false,
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
  API: {
    GraphQL: {
      endpoint: import.meta.env.VITE_GRAPHQL_ENDPOINT || '',
      region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
      defaultAuthMode: 'userPool' as const,
    },
  },
  Storage: {
    S3: {
      bucket: import.meta.env.VITE_S3_DOCUMENTS_BUCKET || '',
      region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
    },
  },
};

// Only configure Amplify if we have the required config
if (import.meta.env.VITE_COGNITO_USER_POOL_ID) {
  Amplify.configure(awsConfig, {
    API: {
      GraphQL: {}
    }
  });
  
  console.log('✅ Amplify configured with GraphQL subscriptions enabled');
  console.log('📡 GraphQL Endpoint:', import.meta.env.VITE_GRAPHQL_ENDPOINT);
} else {
  console.warn('⚠️ Amplify not configured - missing Cognito configuration');
}

export default awsConfig;